import { render, staticRenderFns } from "./cancellation-feedback.vue?vue&type=template&id=193c09ec&scoped=true&"
import script from "./cancellation-feedback.vue?vue&type=script&lang=js&"
export * from "./cancellation-feedback.vue?vue&type=script&lang=js&"
import style0 from "./cancellation-feedback.vue?vue&type=style&index=0&id=193c09ec&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "193c09ec",
  null
  
)

export default component.exports